//#region src/translations/es_GT.json
var home = {
	"title": "Vana Card",
	"increment_action": "Sumar",
	"decrement_action": "Restar",
	"increment_hint": "Presiona el botón para aumentar el contador.",
	"posts_title": "Publicaciones",
	"load_posts_action": "Cargar publicaciones",
	"build_title": "Ambiente",
	"modal_title": "Modal",
	"open_modal_action": "Abrir modal",
	"example_dialog_title": "Modal de ejemplo",
	"example_dialog_description": "Este modal viene del sistema de modal-views restaurado en @vana/core.",
	"example_dialog_close_action": "Cerrar"
};
var es_GT_default = { home };
//#endregion
export { es_GT_default as default, home };

//# sourceMappingURL=es_GT.js.map